import { Box, Paper, Typography } from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { PrimaryButton } from "@components/Buttons/PrimaryButton";
import { colors } from "@components/ui/colors";
import { getPhoneNumberLocationLabel } from "../helper/get-location-label.helper";

interface SelectedPhoneNumberCardProps {
    selected: PhoneNumber;
    onConfirm?: () => void;
}

export const SelectedPhoneNumberCard: React.FC<SelectedPhoneNumberCardProps> = ({
    selected,
    onConfirm,
}) => {

    const location = getPhoneNumberLocationLabel(selected);

    return (
        <Paper
            elevation={0}
            sx={{
                border: `1.5px solid ${colors.orange[200]}`,
                borderRadius: "14px",
                p: 2,
                background: colors.orange[50],
                boxShadow: `0 2px 10px ${colors.orange[200]}33`,
            }}
        >
            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.25, mb: 2 }}>
                <CheckCircleRoundedIcon
                    sx={{
                        fontSize: 20,
                        color: colors.orange[500],
                        mt: 0.15,
                    }}
                />

                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                        sx={{
                            fontSize: 11,
                            fontWeight: 800,
                            color: colors.orange[500],
                            letterSpacing: "0.05em",
                            textTransform: "uppercase",
                            mb: 0.5,
                        }}
                    >
                        Selected number
                    </Typography>

                    <Typography
                        sx={{
                            fontSize: 20,
                            fontWeight: 800,
                            color: colors.gray[500],
                            letterSpacing: "-0.02em",
                            lineHeight: 1.15,
                            mb: 0.4,
                        }}
                    >
                        {selected.friendlyName}
                    </Typography>

                    <Typography
                        sx={{
                            fontSize: 12,
                            color: colors.gray[400],
                            fontWeight: 500,
                        }}
                    >
                        {location}
                    </Typography>
                </Box>
            </Box>

            <PrimaryButton
                fullWidth
                onClick={onConfirm}
                endIcon={<ArrowForwardIcon />}
                sx={{
                    borderRadius: "10px",
                    fontSize: 13,
                    fontWeight: 700,
                    py: 0.95,
                }}
            >
                Confirm and continue
            </PrimaryButton>
        </Paper>
    );
};